import { QueryClient } from '@tanstack/react-query';
import { personalizationQueries } from '@/queries/communication/personalization/personalization.query';

export const personalizationLoader = async (queryClient: QueryClient) => {
  try {
    return await queryClient.ensureQueryData(personalizationQueries.all());
  } catch (error) {
    return { categories: [] };
  }
};
